import { motion } from "framer-motion";
import { EASE } from "../../config";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

const line = {
  hidden: { y: "108%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: 0.15 + i * 0.12 } }),
};

export const LineReveal = ({ lines, as: Tag = "h1", className = "", lineClassName = "", lastClassName = "", testId }) => (
  <motion.div initial="hidden" animate="show">
    <Tag className={className} data-testid={testId}>
      {lines.map((l, i) => (
        <span key={l} className="block overflow-hidden pb-[0.08em]">
          <motion.span className={`block ${lineClassName} ${i === lines.length - 1 ? lastClassName : ""}`} custom={i} variants={line}>
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  </motion.div>
);

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p className={`flex items-center gap-3 text-xs uppercase tracking-[0.28em] ${light ? "text-[#E9E4DA]" : "text-[#4A525A]"} ${className}`}>
    <span className="h-px w-8 bg-current" />
    {children}
  </p>
);
